import React, { useState } from 'react';
import { X, Send, Star } from 'lucide-react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

export const ReviewModal = ({ isOpen, onClose }) => {
  const [review, setReview] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!review.trim()) {
      alert('Please enter your review');
      return;
    }

    const message = `Hi, here is my review: ${review}`;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/919007667528?text=${encodedMessage}`, '_blank');
    
    setReview('');
    onClose();
  };

  const handleClose = () => {
    setReview('');
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="max-w-md p-0 overflow-hidden">
        <div className="bg-gradient-to-r from-rose-600 to-pink-600 text-white p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Star className="w-6 h-6 fill-white" />
              <div>
                <h2 className="text-2xl font-bold">Write a Review</h2>
                <p className="text-sm text-rose-50 mt-1">Share your experience with us</p>
              </div>
            </div>
            <button
              onClick={handleClose}
              className="text-white hover:bg-white/20 p-2 rounded-full transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div>
            <Label htmlFor="review" className="text-slate-700 font-medium mb-2 block">
              Your Review *
            </Label>
            <Textarea
              id="review"
              value={review}
              onChange={(e) => setReview(e.target.value)}
              placeholder="Tell us about your experience with Ushakiran Medicos..."
              className="w-full min-h-[150px] resize-none"
              required
            />
          </div>

          <Button
            type="submit"
            className="w-full bg-gradient-to-r from-rose-600 to-pink-600 text-white hover:from-rose-700 hover:to-pink-700 py-6 text-base font-semibold shadow-lg hover:shadow-xl transition-all duration-300"
          >
            <Send className="w-5 h-5 mr-2" />
            Send Review via WhatsApp
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};